var map = {
	"./en/document.json": 85658,
	"./en/error.json": 299,
	"./en/history.json": 20343,
	"./en/otp.json": 11569,
	"./en/resend.json": 54739,
	"./en/search.json": 48767,
	"./th/document.json": 3918,
	"./th/error.json": 84970,
	"./th/history.json": 28640,
	"./th/otp.json": 86545,
	"./th/resend.json": 37561,
	"./th/search.json": 72151,
	"src/assets/i18n/en/document.json": 85658,
	"src/assets/i18n/en/error.json": 299,
	"src/assets/i18n/en/history.json": 20343,
	"src/assets/i18n/en/otp.json": 11569,
	"src/assets/i18n/en/resend.json": 54739,
	"src/assets/i18n/en/search.json": 48767,
	"src/assets/i18n/th/document.json": 3918,
	"src/assets/i18n/th/error.json": 84970,
	"src/assets/i18n/th/history.json": 28640,
	"src/assets/i18n/th/otp.json": 86545,
	"src/assets/i18n/th/resend.json": 37561,
	"src/assets/i18n/th/search.json": 72151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20797;